const isMobileMixin = {
  data: () => ({
    windowWidth: window.innerWidth,
  }),
  computed: {
    isMobile() {
      const mobileBreakPoint = 1096;
      return this.windowWidth <= mobileBreakPoint;
    },
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  created() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};

export default isMobileMixin;
